import SmsOutbox from '@/modules/smsoutbox/views/SmsOutbox.vue';

export const SmsOutboxRoutes = [
    {
        name: 'outbox',
        path: '/outbox',
        component: SmsOutbox,
    }
];
